import axios from 'axios'
import requestInterceptor from '../../requestInterceptor'
import responseInterceptor from '../../responseInterceptor'
import { kitchenServiceUrl } from '../../../../urls'

const headers = {
  'Content-Type': 'application/json',
  'X-Requested-With': 'XMLHttpRequest',
}

const kitchenInstance = axios.create({
  baseURL: kitchenServiceUrl,
  headers,
})

kitchenInstance.interceptors.request.use(config => {
  return requestInterceptor(config)
}, error => Promise.reject(error))

kitchenInstance.interceptors.response.use(response => response, error => {
	return responseInterceptor(error)
})

export default kitchenInstance
